import type { ParseKeys } from "i18next";

import type { IIconName } from "@/components/icon";
import type { IExclusive } from "@/interfaces";

export interface IIcon {
  iconName: IIconName;
}
export interface IName {
  name: ParseKeys<"sidebar">;
}
export interface IPath {
  path: string;
}

export enum ISidebarChildTypeEnum {
  Sidebar = "sidebar",
  Tab = "tab",
}

export interface ISidebarChildType {
  type?: ISidebarChildTypeEnum;
}

export type IChildItem = IName & IPath & ISidebarChildType & Partial<IIcon>;

export interface IClick {
  onClick: () => void;
}
export interface IChild {
  child?: IChildItem[];
}

export type IMenuItem = IExclusive<IPath & IChild, IClick>;

export type ISidebarItems = {
  items: IMenuItem;
} & IName &
  IIcon;

export type IFooterSidebarItem = {
  items: IExclusive<IPath, IClick>;
  className?: string;
} & IName &
  IIcon;

export interface ISidebarMenuProps {
  name: string;
}
